module.exports = __webpack_public_path__ + "static/media/credit-card.71a5ac50.svg";